import styled from 'styled-components';
import { CodeEditor } from './CodeEditor';
import { EditorLanguage } from './utils';

const StyledCodeEditor = styled(CodeEditor)`
  width: calc(100% - 2px) !important;
  position: relative;
  border: 1px solid rgb(204, 204, 204);
  border-bottom-width: 0;
  border-radius: 3px 3px 0 0;
  margin-bottom: -1px;
  z-index: 1;
  background: #eeeeee !important;
`;

interface Props {
  value: string;
}
/**
 * A copy of `CodeEditor` that is immutable.
 *
 * Only supports one line, which will have `0` as the gutter number. The mode
 * is groovy.
 *
 * @param value The content of the line.
 */
export const ImmutableCodeEditor = ({ value }: Props) => {
  return (
    <StyledCodeEditor
      value={value}
      language={EditorLanguage.GROOVY}
      readOnly
      firstLineNumber={0}
      maxLines={1}
      minLines={1}
    />
  );
};
